// Helpers partilhados pelas vistas de Arrendamentos (Módulo 5).

// Cor por estado do contrato — classes já compiladas em index.css (grep-verificadas).
// Classificador é o statusCode; fallback neutro para estados desconhecidos.
export const RENTAL_STATUS_BADGE: Record<string, string> = {
  agendado: "bg-yellow-500/10 text-yellow-700",
  ativo: "bg-green-500/10 text-green-700",
  terminado: "bg-muted text-secondary-text",
  rescindido: "bg-destructive/10 text-destructive",
};

export const rentalStatusBadgeClass = (statusCode: string): string =>
  RENTAL_STATUS_BADGE[statusCode] ?? "bg-muted text-secondary-text";

// Janela do alerta de fim de prazo [5.2.2].
export const RENTAL_EXPIRY_WINDOW_DAYS = 60;

// Dias inteiros de hoje (meia-noite) até endDate (meia-noite). null se sem termo/inválido.
export const daysUntil = (endDate: string | null | undefined): number | null => {
  if (!endDate) return null;
  const end = new Date(endDate);
  if (Number.isNaN(end.getTime())) return null;
  const now = new Date();
  const endMid = new Date(end.getFullYear(), end.getMonth(), end.getDate());
  const todayMid = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  return Math.round((endMid.getTime() - todayMid.getTime()) / 86400000);
};

// true se o contrato ativo termina dentro da janela de alerta (inclui hoje).
export const isExpiringSoon = (
  statusCode: string,
  endDate: string | null | undefined,
): boolean => {
  if (statusCode !== "ativo") return false;
  const days = daysUntil(endDate);
  return days !== null && days >= 0 && days <= RENTAL_EXPIRY_WINDOW_DAYS;
};
